export default __webpack_public_path__ + "static/media/checklist.291140fe.png";